import { DocumentRepository } from "@core/data/repositories/document.repository";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class UpdateSignDocumentUseCase {
    constructor(
        @inject(DocumentRepository)
        private readonly documentRepository: DocumentRepository,
    ) {}

    async execute(
        signatureId: number,
        documentId: number,
        signature: string,
        userId: number,
    ): Promise<boolean> {
        const editSignDocument = await this.documentRepository.editSignDocument(
            signatureId,
            documentId,
            signature,
            userId,
        );
        if (editSignDocument.isLeft()) {
            ToastManagerStore.error(editSignDocument.getLeftOrThrow().message);
        }
        return editSignDocument.getOrThrow();
    }
}
